









































import Vue from 'vue'
import Modal from '@/pmd/components/common/Modal.vue'
import { Location } from '@/models'
import firebase from 'firebase/compat/app'

export default Vue.extend({
  props: ['modalShow', 'googleConnection', 'currentLocationId'],
  components: {
    Modal,
  },
  data() {
    return {
      popupWidth: 500,
      loader: false,
      location: {} as Location,
    }
  },
  async mounted() {
    this.location = new Location(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.currentLocationId
      )
    )
  },
  methods: {
    async closeModal() {
      this.$root.$emit('close-modal')
    },
    async makeItPrimary() {
      this.loader = true
      if (this.googleConnection.id) {
        this.location.primaryGoogleConnectionId = this.googleConnection.id
        this.location.googleAnalyticsViewId = undefined
        this.location.googleAnalyticsViewId = undefined
        this.location.googleAdwordsId = undefined
        await this.location.ref.update({
          primary_google_connection_id: this.googleConnection.id,
          google_analytics_view_id: firebase.firestore.FieldValue.delete(),
          google_adwords_id: firebase.firestore.FieldValue.delete(),
          date_updated: firebase.firestore.FieldValue.serverTimestamp(),
        })
        this.location = new Location(
          await this.$store.dispatch(
            'locations/getCurrentLocation',
            this.currentLocationId
          )
        )
      }
      this.$root.$emit('gmb-primary-change')
    },
    tryagain() {
      this.$root.$emit('google-connect')
    },
  },
})
